export default __webpack_public_path__ + "static/media/imperial.e848a6d9.png";